function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent, Fragment } from "react";
import Select from "react-select";
import SelectStyle from "/components/templates-generator/fields/dropdown/react-select.scss.js";
import { INDUSTRIES_CONFIG, getIndustryOptionByValue } from "services/industries/industries-service";
import classnames from "classnames";
import ManageOptionsComponent from "/components/segments/industry-selection/manage-options/manage-options-component";
import ArrowRight from "/static/svg/arrow-right.svg";
import { componentStyles, stepNumberStyles } from "./industry-selection-first-step-component.scss";
class IndustrySelectionFirstStepComponent extends PureComponent {
    renderStepNumber(stepNumber) {
        return /*#__PURE__*/ _jsxs(Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${stepNumberStyles.__hash}` + " " + "step-number-circle",
                    children: stepNumber
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: stepNumberStyles.__hash,
                    children: stepNumberStyles
                })
            ]
        });
    }
    renderIndustryQuestion() {
        const { selectedIndustry, handleSelectIndustryChange } = this.props;
        const questionHtml = INDUSTRIES_CONFIG.firstStepHtmlTitle;
        return /*#__PURE__*/ _jsxs("div", {
            className: classnames("industry-question-wrapper", {
                "industry-selected": !!selectedIndustry
            }),
            children: [
                this.renderStepNumber(1),
                /*#__PURE__*/ _jsx("div", {
                    className: "industry-question",
                    dangerouslySetInnerHTML: {
                        __html: questionHtml
                    }
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: `jsx-${SelectStyle.__hash}` + " " + "industry-selection-options-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx(Select, {
                            name: "industry-options",
                            isClearable: false,
                            isSearchable: false,
                            styles: {
                                control: (base)=>{
                                    return _object_spread_props(_object_spread({}, base), {
                                        fontSize: "14px",
                                        height: "40px",
                                        boxShadow: "none",
                                        minWidth: "320px"
                                    });
                                }
                            },
                            placeholder: "Choose one from the list",
                            value: selectedIndustry,
                            onChange: handleSelectIndustryChange,
                            options: INDUSTRIES_CONFIG.options
                        }),
                        /*#__PURE__*/ _jsx(_JSXStyle, {
                            id: SelectStyle.__hash,
                            children: SelectStyle
                        })
                    ]
                })
            ]
        });
    }
    renderManageOptionsQuestion() {
        const { selectedIndustry, selectedManageOptions, handleOptionsSelected, onNextClick } = this.props;
        const questionHtml = INDUSTRIES_CONFIG.secondStepHtmlTitle;
        const diclaimer = INDUSTRIES_CONFIG.selectionDisclaimerHtml;
        const industryData = getIndustryOptionByValue(selectedIndustry) || {};
        return /*#__PURE__*/ _jsxs("div", {
            className: classnames("manage-question-wrapper", {
                visible: !!selectedIndustry
            }),
            children: [
                this.renderStepNumber(2),
                /*#__PURE__*/ _jsx("div", {
                    className: "manage-options-question",
                    dangerouslySetInnerHTML: {
                        __html: questionHtml
                    }
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "select-disclaimer",
                    dangerouslySetInnerHTML: {
                        __html: diclaimer
                    }
                }),
                /*#__PURE__*/ _jsx(ManageOptionsComponent, {
                    options: industryData.manageOptions || [],
                    selectedOptions: selectedManageOptions,
                    onSelect: handleOptionsSelected
                })
            ]
        });
    }
    onNextClick() {
        const { nextStepCallback } = this.props;
        nextStepCallback();
    }
    renderNextButton() {
        const { selectedManageOptions } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: classnames("next-wrapper", {
                visible: selectedManageOptions.length > 0
            }),
            children: /*#__PURE__*/ _jsxs("a", {
                className: "next-link",
                onClick: this.onNextClick,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "next-circle",
                        children: /*#__PURE__*/ _jsx(ArrowRight, {
                            className: "arrow"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "next-link",
                        children: "Next"
                    })
                ]
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + "industry-selection-first-step-wrapper",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "industry-selection-questions",
                    children: [
                        this.renderIndustryQuestion(),
                        this.renderManageOptionsQuestion()
                    ]
                }),
                this.renderNextButton(),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.onNextClick = this.onNextClick.bind(this);
        this.renderNextButton = this.renderNextButton.bind(this);
    }
}
export { IndustrySelectionFirstStepComponent as default };
